export default [
    {
        id:"btc",
        name: "Bitcoin",
        symbol: "BTC",
        coinpaymentId:"BTC"
    
    },

    {
        id:"eth",
        name: "Ethereum",
        symbol: "ETH",
        coinpaymentId:"ETH"

    },


    {
        id:"bnb",

        name: "Binance Coin",
        symbol: "BNB",
        coinpaymentId:"BNB.BSC"

    },

    {
        id:"trx",
        name: "Tron",
        symbol: "TRX",
        coinpaymentId:"TRX"

    },
    
    {
        id:"busd",
        name: "Binance USD",

        symbol: "BUSD",
        price: 1,
        coinpaymentId:"BUSD.BEP20"


    },

    {
        id:"ltc",

        name: "Litcoin",
        symbol: "LTC",
        coinpaymentId:"LTC"

    },
    {
        id:"usdt-erc20",
        name: "USDT",
        symbol: "USDT",
        price: 1,
        coinpaymentId:"USDT.ERC20"


    },
    {
        id:"usdt-trc20",

        name: "USDT",
        symbol: "USDT",
        price: 1,
        coinpaymentId:"USDT.TRC20"

        

    },
    {
        id:"usdt-bep20",

        name: "USDT",
        symbol: "USDC",
        price: 1,
        coinpaymentId:"USDT.BEP20"

    },

   
   

]